import React from 'react';
import clsx from 'clsx';
import {getZIndex} from "../Utility/html";

export const MODAL_FADE_CLASSES = [
  "fixed h-full w-full top-0 bottom-0 left-0 right-0 px-4 lg:px-8",
  "bg-black bg-opacity-70 transition-opacity",
  "flex items-center justify-center"
];

export const MODAL_FADE_STYLES = {
  zIndex: getZIndex("modalFadeScreen", 500_000)
}

export default function ModalFadeScreen({children, className,
  handleClose, ...props}) {

  className ||= MODAL_FADE_CLASSES;

  return <div style={MODAL_FADE_STYLES} onClick={handleClose}
    className={clsx(className)}>{children}</div>
}
